import { SubmitTraitsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import getMediaAppearanceAdjustedTraits from './get-media-appearance-adjusted-traits';
import getMediaAppearanceModifiedTraits from './get-media-appearance-modified-traits';

const createSubmitTraitsMediaAppearanceHandler =
  ({ prefix }) =>
  (flowData, context) => {
    const { modifiedAttributes, lastModifiedAttributes, state, initialState } = context;

    const adjusted = getMediaAppearanceAdjustedTraits({
      prefix,
      modifiedAttributes,
    });
    const modified = getMediaAppearanceModifiedTraits({
      prefix,
      modifiedAttributes: lastModifiedAttributes,
      state,
      initialState,
    });

    return SubmitTraitsGenerationContract.create({ ...adjusted, ...modified });
  };

export default createSubmitTraitsMediaAppearanceHandler;
